module.exports = __webpack_public_path__ + "img/office365Icon.950aee67.svg";